// TODO
export const bankLogo = 'data:image/jpeg;base64,/9j/4AAQS_TODO';
